import * as Website from '../../Config/Website.js';
import fv from '../../Modules/fv.js';


const preinit = () => {

}

const init = () => {
  fv();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}